<template>
  <div>
    <div class="pxkeji-right-box">
      <a-form class="ant-advanced-search-form">
        <a-row :gutter="24">
          <a-col :span="8">
            <a-form-item label="用户">
              <a-input placeholder="姓名/手机号/用户名" v-model="where.keyword.name" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24" :style="{ textAlign: 'right' }">
            <a-button type="primary" @click="searchList">搜索</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="pxkeji-right-box">
      <a-table
        :columns="list.columns"
        rowKey="id"
        :pagination="list.pagination"
        @change="onChange"
        :dataSource="list.datas"
        :loading="isloading"
        :rowSelection="{type:'radio',onChange:onRowChange,selectedRowKeys:selectRows,getCheckboxProps:getCheckProp}"
        :locale="{emptyText:'暂无数据'}"
      >
        <span slot="roles" slot-scope="roles">
          <a-tag v-for="info in roles" :key="info.id" color="green">{{info.name}}</a-tag>
        </span>
      </a-table>
      <div class="totalbox" style="float: left;">
        <div>
          <span>共有：{{list.pagination.total}}条数据</span>
        </div>
      </div>
      <div>
        <pxkeji-btn name="确认选择" type="primary" @click="confirmSelect" />
      </div>
    </div>
  </div>
</template>
<script>
var that;

const columns = [
  {
    dataIndex: "id",
    key: "id",
    align: "center",
    title: "用户编号"
  },
  {
    dataIndex: "name",
    key: "name",
    align: "center",
    title: "用户名"
  },
  {
    dataIndex: "realName",
    key: "realName",
    align: "center",
    title: "真实姓名"
  },
  {
    dataIndex: "telephone",
    key: "telephone",
    align: "center",
    title: "手机号码"
  },
  {
    dataIndex: "roles",
    key: "roles",
    align: "center",
    title: "角色",
    scopedSlots: { customRender: "roles" }
  }
];

export default {
  name: "userList",
  props: {
    id: String
  },
  data() {
    return {
      list: {
        columns, //表头
        datas: [], //数据
        pagination: {
          //分页器
          showQuickJumper: true,
          hideOnSinglePage: true,
          total: 0,
          current: 1, //页码
          defaultPageSize: 10 //页容
        }
      },
      where: {
        //查询条件
        keyword: {
          //搜索条件
          name: "",
          status: 1
        }
      },
      selectRows: [], //选中项编号
      selectUserInfo: [],
      isloading: false
    };
  },
  mounted: function() {
    this.$nextTick(function() {
      that = this;
      this.GetList();
    });
  },
  watch: {
    selectRows: function() {}
  },
  methods: {
    GetList() {
      //获取用户列表
      this.isloading = true;
      this.clearRows();
      this.$api.user
        .pageListAdmin(
          this.list.pagination.current,
          this.list.pagination.defaultPageSize,
          this.where.keyword.name,
          this.where.keyword.status
        )
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.list.datas = res.data.records;
            this.list.pagination.total = Number(res.data.total);
          } else {
            this.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },

    onChange(page) {
      //页面切换回调
      this.list.pagination.current = page.current;
      this.GetList();
    },
    onRowChange(selectedRowKeys, selectedRows) {
      //table 多选
      this.selectRows = selectedRowKeys;
      this.selectUserInfo = selectedRows;
    },
    clearRows() {
      //清空选中项
      this.selectRows = [];
    },
    searchList() {
      this.list.pagination.current = 1;
      this.GetList();
    },
    clear() {
      //清空搜索条件
      for (var info in this.where.keyword) {
        this.where.keyword[info] = "";
      }
    },
    getCheckProp(record) {
      if (this.id == record.id) {
        this.selectRows.push(record.id);
        this.selectUserInfo.push(record);
      }
      return {
        props: {
          defaultChecked: this.id == record.id
        }
      };
    },
    confirmSelect() {
      if (this.selectUserInfo.length == 0) {
        this.$message.error("请选择用户");
        return;
      }
      that.$emit("callbackMethod", this.selectUserInfo[0]);
    }
  }
};
</script>

<style>
.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

#components-form-demo-advanced-search .ant-form {
  max-width: none;
}

#components-form-demo-advanced-search .search-result-list {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  text-align: center;
  padding-top: 80px;
}
</style>

